import { Box, Button } from "@mui/material";
import React from "react";
import FormRender from "components/form-builder/FormRender";
import { useAuth } from "hooks/useAuth";
import { useSubscribeSocket } from "hooks/useSocket";
import useSaveSurveyResponse from "hooks/useSaveSurveyResponse";

function transformPayload(defaultValues) {
  const formValues = {};
  Object.entries(defaultValues).forEach(([key, value]) => {
    formValues[key] = value?.answer;
  });
  return formValues;
}

const QuestionerSurveyPage = ({
  questioner,
  visibleBackButton,
  handleBack,
  defaultValues = {},
  progress = {},
}) => {
  const { user, logout, logoutLoading } = useAuth();
  useSubscribeSocket();
  const userType = user.userType ?? user.usertype;
  const formSchema = questioner?.formJson;

  const { handleSubmit } = useSaveSurveyResponse({
    formSchema,
    questioner,
    userType,
    visibleBackButton,
    handleBack,
  });

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          gap: 2,
        }}
      >
        {visibleBackButton ? (
          <Button variant="contained" onClick={handleBack}>
            Go Back
          </Button>
        ) : (
          <div></div>
        )}
        <Button disabled={logoutLoading} variant="contained" onClick={logout}>
          {logoutLoading ? "Logging out..." : "Logout"}
        </Button>
      </Box>
      <FormRender
        userType={userType}
        formSchema={formSchema}
        formSubmitHandler={handleSubmit}
        handleNextStep={handleSubmit}
        stepCount={progress?.stepCount ?? 0}
        key={`${JSON.stringify(progress)}`}
        defaultValues={transformPayload(defaultValues)}
      />
    </>
  );
};

export default QuestionerSurveyPage;
